/**
 * User Portal BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AssetsResponse { 
    currencyId: number;
    currencyName: string;
    currencyTicker: string;
    chainId: number;
    chainName: string;
    amount: number;
    amountInUsd: number;
}

